<template>
  <div id="app" @click="$root.$emit('bv::hide::popover')">
    
    <Navbar v-if="$route.name != 'chat' && $route.name != 'chat project' && $route.name!= 'chatlive'"></Navbar>
    <router-view :key="$route.path" class="textcolor"/>
    <Window></Window>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from '@/components/Navbar'
import Window from '@/components/window/Window'
import { EventBus } from '@/event-bus';
export default {
  name: 'home',
  components: {
    Navbar,
    Window
  },
  data() {
    return {
      isUploading: false
    }
  },
  mounted() {
    let self = this;
    window.addEventListener("beforeunload", function (e) {
          if (!self.isUploading) {
              return undefined;
          } else {
            var confirmationMessage = "If you leave before the end of your uploads, the videos won't be saved in the Quanteec Platform.";

            (e || window.event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
          } 
      });
    EventBus.$on("preventCloseWindow", function() {
      self.isUploading = true;
    });
    EventBus.$on("allowCloseWindow", function() {
      self.isUploading = false;
    });
  }
}
</script>

<style lang="scss">

body {
  line-height: 1 !important;
}

$backgroundlogin: #001621;
$backgroundlogin2: #202b30;

$quanteecorange: #f98e35;
$quanteecorange2: #e68333;

$quanteecblue: #2F90B0;
$quanteecdarkblue1: #113448;
$quanteecdarkblue2: #153e52;
$quanteecdarkblue3: #2a5d77;

$quanteecgrey: #f2f2f2;
$quanteecgrey2: #dfdfdf;
$quanteecgrey3: #484a46;
$quanteecgrey4: #787976;
$quanteecgrey5: #aac8d4;

$quanteecred: #ba0000;
$quanteecred2: #a80000;

$quanteecwhite: #FBFCFC;
$quanteecwhite2: #fbfbfb;

$quanteecgreen: #14BF98;
$quanteecyellow: #FEDDA8;
$quanteecblack: #202b30;
$quanteeccut: #28a745;
$quanteecarchive: #17a2b8;


$quanteechover: #048F94;

//#F7DC6FfpointerEl

$backgroundnavbar: #113448;
$backgrounddark: #0f182f;
$backgroundblue: #2F90B0;

$colortextdark: #4e505d;
$colortextgrey: #9a9fa2;
$colortextnavbar: #fff;
$colortextnavbarhover: #fff;

$msstreamblue1: #00b0ff;
$msstreamblue2: #0bffff;
$msstreamred1: #ff0037;
$msstreamyellow1: #FEDDA8;

.clickable {
  cursor: pointer;
}

.mypanel {
    background-color: $quanteecgrey;
    margin: 15px 0px 0px;
    padding: 15px;
    border: 1px solid white;
}

.btn-lightgrey {
  color: #000 !important;
  background-color: #d6dce2 !important;
  border-color: #d6dce2 !important;//#6c757d;
  &:hover {
      background-color: #c2c8ce !important;
      border-color: #c2c8ce !important;//#6c757d;
  }
}

.oksearch {
    border: 2px solid;
    border-radius: 15px;
    padding: 10px 10px;
    background-color: rgba($quanteecgreen, 0.14);
    border-color: $quanteecgreen;
}

.bg-dark1 {
  background-color: $backgroundlogin !important;
}
.border-dark1 {
  border-color: $backgroundlogin !important;
}
.bg-dark2 {
  background-color: $backgroundlogin2 !important;
}
.border-dark2 {
  border-color: $backgroundlogin2 !important;
}

.navbar-msstream .navbar-nav .nav-link {
    color:rgba($colortextnavbar, 1);
}
.navbar-msstream .navbar-brand {
    color: $colortextnavbar;
}
.navbar-msstream .navbar-toggler {
  color: rgba($colortextnavbar, 0.8) !important;
  border-color: rgba($colortextnavbar, 0.8);
}
.navbar-msstream .navbar-nav .nav-link:hover {
  color: rgba($quanteecgreen, 1) !important;
}
.navbar-msstream {
  padding: 0 16px !important;
  border:1px solid black;
}

.bg-navbar-msstream {
  //background-color: $backgroundnavbar !important;
  background-image: url("assets/fond_navbar.png");
}

.marginal {
  margin-top: 30px;
  margin-bottom: 30px;
}

.marginalsm {
  margin-top: 15px;
  margin-bottom: 15px;
}

.marginaltop {
  margin-top: 30px;
}

.marginaltopsm {
  margin-top: 15px;
}

.marginalbot {
  margin-bottom: 30px;
}

.marginalbotsm {
  margin-bottom: 15px;
}

.bg-msstream {
//  background-color: $backgroundnavbar !important;
  background-image: url("assets/fond_msstream.jpg");
  opacity: 0.9;  
}

.border-msstream {
  border-color: $backgroundnavbar !important;
}

.darkBack {
 color: $colortextgrey;
 background-color: $backgroundnavbar;
}

.textcolor {
  color: $colortextdark;
}

.btn-nothing {
  color: $quanteecdarkblue3 !important;
  background-color: transparent !important;
  padding: 3px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  cursor: default !important;
}

.btn-empty {
  color: $quanteecdarkblue3 !important;
  background-color: transparent !important;
  padding: 4px !important;
  margin: 4px !important;
  line-height: 1 !important;
  &:hover {
    color: $quanteechover !important;
    background-color: white !important;
  }    
}

.btn-emptyW {
  color: white !important;
  background-color: transparent !important;
  padding: 5px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    background-color: white !important;
    border: 1px solid $quanteechover !important;
  }    
}

.btn-emptyG {
  color: $quanteecgreen !important;
  background-color: white !important;
  padding: 5px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    background-color: white !important;
    border: 1px solid $quanteechover !important;
  }    
}

.btn-emptyBW {
  color: white !important;
  background-color: transparent !important;
  padding: 5px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
  }    
}

.btn-emptyBWDB {
  color: white !important;
  background-color: rgba(17, 52, 72, 1) !important;
  padding: 4px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
  }    
}

.btn-emptyNoB {
  color: $quanteecdarkblue3 !important;
  background-color: transparent !important;
  padding: 5px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
}

.btn-emptyB {
  color: $quanteecdarkblue3 !important;
  background-color: transparent !important;
  padding: 5px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    background-color: white !important;
    border: 1px solid $quanteechover !important;
  }    
}

.btn-emptyBB {
  color: $quanteecdarkblue3 !important;
  background-color: transparent !important;
  padding: 7px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
  border: 1px solid $quanteecdarkblue3 !important;
  border-top-right-radius: 0px !important;
  border-bottom-right-radius: 0px !important;  
&:hover {
    color: $quanteechover !important;
    background-color: white !important;
    border: 1px solid $quanteechover !important;
  }    
}

.btn-emptyBBx {
  color: $quanteecdarkblue3 !important;
  background-color: transparent !important;
  padding: 7px 12px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
  border: 1px solid $quanteecdarkblue3 !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;  
  border-left: 0px !important;
&:hover {
    color: $quanteechover !important;
    background-color: white !important;
    border: 1px solid $quanteechover !important;
  border-left: 0px !important;
  }    
}


.btn-emptyB2 {
  color: $quanteecdarkblue3 !important;
  background-color: transparent !important;
  padding: 5px 10px !important;
  margin: 0px !important;
  line-height: 1 !important;
  transition: .15s all ease-in-out;
}

.pointerOrange {
  cursor: pointer;
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecorange  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecorange !important;
  transition: .15s all ease-in-out;
  padding: 6px 8px !important;
  margin: 0px !important;
  line-height: normal !important;
  font-size: 14px !important;
&:hover {
    color: $quanteecorange !important;
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid $quanteecorange !important;
    background-color: #FBFCFC !important;
    text-decoration: none;

  }
}

.pointerBlue {
  cursor: pointer;
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecblue  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecblue !important;
  transition: .15s all ease-in-out;
  padding: 6px 8px !important;
  margin: 0px 15px !important;
  font-size: 14px !important;
  line-height: normal !important;
&:hover {
    color: $quanteecblue !important;
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid $quanteecblue !important;
    background-color: #FBFCFC !important;
    text-decoration: none;

  }
}


.btn-mswarning {
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecorange  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecorange !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteecorange !important;
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid $quanteecorange !important;
    background-color: #FBFCFC !important;
    text-decoration: none;

  }
/*
  color: #fff !important;
  background-color: $quanteecorange !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecdarkblue3 !important;

  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteecorange !important;
    border: 0.1rem solid $quanteecdarkblue3 !important;
    background-color: #FBFCFC !important;
    text-decoration: none;

  }
  */
}

.btn-msstreamblue {
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecblue  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    box-shadow: rgba($quanteechover, 0.3) 4px 8px 20px, rgba($backgroundblue, 0.3) 4px 8px 20px;
    border: 0.1rem solid $quanteechover !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
    //transform: scale(1.005);
  }

  /*
  &:hover {
    box-shadow: rgba($backgroundblue, 0.3) 4px 8px 20px, rgba($backgroundblue, 0.3) 4px 8px 20px;
    text-decoration: none;
  }


  border-radius: 18px !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  transition: .15s all ease-in-out;
  &:hover {
    background-color: $quanteecblue !important;
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    transform: scale(1.01);
  }
  */
}


.btn-cut {
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteeccut  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    box-shadow: rgba($quanteechover, 0.3) 4px 8px 20px, rgba($backgroundblue, 0.3) 4px 8px 20px;
    border: 0.1rem solid $quanteechover !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
    //transform: scale(1.005);
  }
}

.btn-archive {
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecarchive  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    box-shadow: rgba($quanteechover, 0.3) 4px 8px 20px, rgba($backgroundblue, 0.3) 4px 8px 20px;
    border: 0.1rem solid $quanteechover !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
    //transform: scale(1.005);
  }
}

 .btn-invisibleN {
  background-color:transparent !important;
  border-radius: 0.25rem !important;
  border: 0rem solid $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  &:hover {
    color: $quanteechover !important;
    text-decoration: none;
  }
 }

 .btn-invisible {
  color: #fff  !important;
  background-color:transparent !important;
  border-radius: 0.25rem !important;
  border: 0rem solid $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  &:hover {
    color: $quanteechover !important;
    text-decoration: none;
  }
 }

 .btn-views {
  color: whitesmoke !important;
  width: 2.3rem;
  height: 2.3rem;
  background-color: black !important;
  background-size: 2.3rem 2.3rem;
  border-radius: 0.25rem !important;
  border: 0rem solid black !important;
  transition: .15s all ease-in-out;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  cursor: default !important;
 }

 .btn-quality {
  color: whitesmoke !important;
  width: 2.3rem;
  height: 2.3rem;
  background: url(assets/hexagonblue.svg) center center no-repeat;
  background-size: 2.3rem 2.3rem;
  border-radius: 0.25rem !important;
  border: 0rem solid $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  cursor: default !important;
 }

 .btn-efficiency {
  color: whitesmoke !important;
  width: 2.3rem;
  height: 2.3rem;
  background: url(assets/hexagonblue_Efficiency.svg) center center no-repeat;
  background-size: 2.3rem 2.3rem;
  border-radius: 0.25rem !important;
  border: 0rem solid $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  cursor: default !important;
 }

 .btn-energy {
  color: whitesmoke !important;
  width: 2.3rem;
  height: 2.3rem;
  background: url(assets/hexagongreen.svg) center center no-repeat;
  background-size: 2.3rem 2.3rem;
  border-radius: 0.25rem !important;
  border: 0rem solid $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
  cursor: default !important;
 }


.btn-darkblue {
  color: #fff  !important;
  background-color: $quanteecdarkblue1  !important;
  border: 0.1rem solid $quanteecdarkblue3 !important;
  border-radius: 0.25rem !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    border: 0.1rem solid $quanteechover !important;
    background-color: $quanteecwhite !important;
    text-decoration: none;
  }
 } 

.btn-darkblueAn {
  color: #fff  !important;
  background-color: $quanteecdarkblue1  !important;
  border: 0.2rem solid $quanteecdarkblue3 !important;
  border-radius: 0.2rem !important;
  transition: .15s all ease-in-out;
  cursor: default !important;
  padding: 0.8rem 1.5rem !important;
 } 


.btn-bordered {
  color: #fff  !important;
  border: 1px solid $quanteecdarkblue3 !important;
  border-left: none !important;
  border-radius: 0rem !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    text-decoration: none;
  }
 } 

.btn-borderedx {
  color: #fff  !important;
  border: 1px solid $quanteecdarkblue3 !important;
  border-left: none !important;
  border-top-left-radius: 0rem !important;
  border-bottom-left-radius: 0rem !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    text-decoration: none;
  }
 } 

.btn-borderedxb {
  color: $quanteecdarkblue3 !important;
  border: 1px solid $quanteecdarkblue3 !important;
  border-left: none !important;
  border-top-left-radius: 0rem !important;
  border-bottom-left-radius: 0rem !important;
  border-top-right-radius: 5px !important;
  border-bottom-right-radius: 5px !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    text-decoration: none;
  }
 } 


.page-item .page-link {
  color: #fff  !important;
  background-color: $quanteecdarkblue1  !important;
  border-color: $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteecdarkblue3 !important;
    border-color: $quanteecdarkblue3 !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
 }

.page-item.active .page-link {
  color: $quanteecgreen  !important;
  background-color: #fff  !important;
  border-color: $quanteecdarkblue3 !important;
  &:hover {
    color: $quanteechover !important;
    border-color: $quanteechover !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
}

.page-item.disabled .page-link {
  color: $quanteecdarkblue3  !important;
  border-color: $quanteecdarkblue3 !important;
  background-color: $quanteecgrey !important;
}

.input-group-text {
  border-color: $quanteecdarkblue3 !important;
} 

.btn-db-sbi {
  color: #fff  !important;
  background-color: $quanteecdarkblue1  !important;
  border-color: $quanteecdarkblue3 !important;
  border: 0rem solid $quanteecdarkblue3 !important;
  padding: 2px 6px !important;
} 

.btn-db-sb {
  color: #fff  !important;
  background-color: $quanteecdarkblue1  !important;
  border-color: $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    border-color: $quanteechover !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
 } 

.btn-db-sb1 {
  color: #fff  !important;
  background-color: $quanteecdarkblue1  !important;
  border-color: $quanteecdarkblue3 !important;
  transition: .15s all ease-in-out;
  border-bottom-right-radius: 0.25rem !important;
  border-top-right-radius: 0.25rem !important;
  &:hover {
    color: $quanteechover !important;
    border-color: $quanteechover !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
 }

.form-control {
  color: $quanteecdarkblue3 !important;
  border-color: $quanteecdarkblue3 !important;
  &:hover {
    color: $quanteechover !important;
  }
}

.btn-greenw {
  color: $quanteecgreen  !important;
  background-color: #fff  !important;
  border: 0.1rem solid $quanteecdarkblue3 !important;
  border-radius: 0.25rem !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    border: 0.1rem solid $quanteechover !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
}
.btn-trans {
  color: #FBFCFC !important;
  background-color: transparent  !important;
  border: 0.1rem solid transparent !important;
  border-radius: 0.25rem !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteechover !important;
    border: 0.1rem solid $quanteechover !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
}


.btn-novisible {
  color: transparent  !important;
  background-color: transparent  !important;
  border: 0.1rem solid transparent !important;
  border-radius: 0.25rem !important;
  transition: .15s all ease-in-out;
}


.btn-msstreambluesmall {
  color: #fff  !important;
  background-color: $quanteecblue  !important;
  border-radius: 12px !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($quanteechover, 0.117647) 1px 2px 7px;
  transition: .15s all ease-in-out;
  padding: 0.275rem 0.4rem !important;
  font-size: 0.76rem !important;
  &:hover {
    color: $quanteechover !important;
    box-shadow: rgba($quanteechover, 0.3) 1px 2px 7px, rgba($quanteechover, 0.3) 1px 2px 7px;
    transform: scale(1.01);
    background-color: #FBFCFC !important;
  }
}

.btn-msstreamorangesmall {
  color: #fff  !important;
  background-color: $quanteecorange  !important;
  border-radius: 12px !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($quanteechover, 0.117647) 1px 2px 7px;
  transition: .15s all ease-in-out;
  padding: 0.275rem 0.4rem !important;
  font-size: 0.76rem !important;
  &:hover {
    color: $quanteechover !important;
    box-shadow: rgba($quanteechover, 0.3) 1px 2px 7px, rgba($quanteechover, 0.3) 1px 2px 7px;
    background-color: #FBFCFC !important;
    border: 1px solid $quanteecorange;
  }
}

.btn-quanteec {
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecred  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecred !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteecred !important;
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid $quanteecred !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
}

.btn-quanteeclg {
  color: black  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecgrey  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid black !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: black !important;
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid black !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
}

.btn-bordergreen {
  box-shadow: rgba($quanteecgreen, 0.117647) 1px 2px 7px, rgba($quanteecgreen, 0.117647) 1px 2px 7px;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecgreen !important;
  transition: .15s all ease-in-out;
  background-color: $quanteecgrey !important;
  &:hover {
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid $quanteecgreen !important;
    text-decoration: none;
  }
}

.btn-cutopen {
  box-shadow: rgba($quanteeccut, 0.117647) 1px 2px 7px, rgba($quanteeccut, 0.117647) 1px 2px 7px;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteeccut !important;
  transition: .15s all ease-in-out;
  &:hover {
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid $quanteeccut !important;
    background-color: white !important;
    text-decoration: none;
  }
}

.btn-archiveopen {
  box-shadow: rgba($quanteecarchive, 0.117647) 1px 2px 7px, rgba($quanteecarchive, 0.117647) 1px 2px 7px;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecarchive !important;
  transition: .15s all ease-in-out;
  &:hover {
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid $quanteecarchive !important;
    background-color: white !important;
    text-decoration: none;
  }
}

.btn-quanteec2 {
  color: #fff  !important;
  background-color: $quanteecdarkblue3  !important;
  border-radius: 18px !important;
  transition: .15s all ease-in-out !important;
  &:hover {
      background-color: $quanteechover !important;
  }
}

.text-green {
  color: $quanteecgreen;
}
.text-darkblue {
  color: $quanteecdarkblue3;
}
.text-blue {
  color: $quanteecblue;
}
.text-red {
  color: $quanteecred;
}
.text-orange {
  color: $quanteecorange;
}
.text-grey {
  color: $quanteecgrey5;
}


.btn-redsmall {
  color: #fff  !important;
  background-color: $quanteecred  !important;
  border-radius: 18px !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  transition: .15s all ease-in-out !important;
  padding: 0.275rem 0.4rem !important;
  font-size: 0.76rem !important;
  &:hover {
      background-color: $quanteecred2 !important;
      box-shadow: rgba($quanteechover, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
      transform: scale(1.01);
  }
}

.btn-bluesmall {
  color: #fff  !important;
  background-color: $quanteecblue  !important;
  border-radius: 18px !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  transition: .15s all ease-in-out !important;
  padding: 0.275rem 0.4rem !important;
  font-size: 0.76rem !important;
  &:hover {
      background-color: $quanteechover !important;
      box-shadow: rgba($quanteechover, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
      transform: scale(1.01);
  }
}

.btn-orangesmall {
  color: #fff  !important;
  background-color: $quanteecorange !important;
  border-radius: 18px !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  transition: .15s all ease-in-out !important;
  padding: 0.275rem 0.4rem !important;
  font-size: 0.76rem !important;
  &:hover {
      background-color: $quanteecorange2 !important;
      box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
      transform: scale(1.01);
  }
}

.btn-greensmall {
  color: #fff  !important;
  background-color: $quanteecgreen  !important;
  border-radius: 18px !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  transition: .15s all ease-in-out !important;
  padding: 0.275rem 0.4rem !important;
  font-size: 0.76rem !important;
  &:hover {
      background-color: $quanteechover !important;
      box-shadow: rgba($quanteechover, 0.3) 1px 2px 7px, rgba($quanteechover, 0.3) 1px 2px 7px;
      transform: scale(1.01);
  }
}

.btn-green {
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecgreen  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecgreen !important;
  transition: .15s all ease-in-out;
  &:hover {
    color: $quanteecgreen !important;
    box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
    border: 0.1rem solid $quanteecgreen !important;
    background-color: #FBFCFC !important;
    text-decoration: none;
  }
}

  .btn-green2 {
  color: #fff  !important;
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
  background-color: $quanteecgreen  !important;
  border-radius: 0.25rem !important;
  border: 0.1rem solid $quanteecgreen !important;
}

.btn-danger {
  color: #fff  !important;
  background-color: $quanteecred  !important;
  &:hover {
      background-color: $quanteecred2 !important;
  }
}

/*
.mycard {
    box-shadow: rgba($backgrounddark, 0.117647) 2px 4px 14px, rgba($backgrounddark, 0.117647) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: rgba(237,245,127, 0.617647);//yellow
    &:hover {
      box-shadow: rgba($backgrounddark, 0.3) 2px 4px 14px, rgba($backgrounddark, 0.3) 2px 4px 14px;
      transform: scale(0.91);
      cursor: pointer;
    }
}
*/

.pointerElt {
  cursor: pointer;
  border-radius: 0.2rem;
  padding: 2px;
  margin: 0px;
  &:hover {
    background-color: white;
    color: $quanteechover !important;
    text-decoration: none;
  }
}

.pointerEltSB {
  cursor: pointer;
  border-radius: 0.2rem;
  padding: 0px;
  margin: 0px;
  &:hover {
    color: $quanteechover !important;
    text-decoration: none;
  }
}

.pointerElt2 {
  cursor: pointer;
  border-radius: 0.2rem;
  padding: 7px;
  margin: 0px;
  &:hover {
    background-color: white;
    color: $quanteechover !important;
    text-decoration: none;
  }
}

.pointerEltVideo {
  cursor: pointer;
  border-radius: 0.2rem;
  padding: 2px;
  margin: 0px 1.2rem 0px 0px;
  color: $quanteecdarkblue3;
  &:hover {
    color: $quanteechover !important;
    text-decoration: none;
  }
}

.mycardLiveOn {
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecred !important;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}
.mycardLiveOnImb {
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecred !important;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}
.mycardLiveOnwA {
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px, 5px -5px 0px $quanteecarchive;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecred !important;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px, 5px -5px 0px $quanteecarchive;
      transform: scale(0.91);
    }
}
.mycardLiveOnwAExp {
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px, 8px 0px 0px $quanteecarchive;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecred !important;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px, 8px 0px 0px $quanteecarchive;
      transform: scale(0.91);
    }
}


.mycardLiveStop {
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblack !important;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}
.mycardLiveStopImb {
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblack !important;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}
.mycardLiveStopwA {
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px, 5px -5px 0px $quanteecarchive;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblack !important;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px, 5px -5px 0px $quanteecarchive;
      transform: scale(0.91);
    }
}
.mycardLiveStopwAExp {
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px, 8px 0px 0px $quanteecarchive;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblack !important;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px, 8px 0px 0px $quanteecarchive;
      transform: scale(0.91);
    }
}

.mycardVOD {
    box-shadow: rgba($quanteecblue, 0.17) 2px 4px 14px, rgba($quanteecblue, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblue !important;
    &:hover {
      box-shadow: rgba($quanteecblue, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}
.mycardVODImb {
    box-shadow: rgba($quanteecblue, 0.17) 2px 4px 14px, rgba($quanteecblue, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblue !important;
    &:hover {
      box-shadow: rgba($quanteecblue, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}
.mycardVODwCut {
    box-shadow: rgba($quanteecblue, 0.17) 2px 4px 14px, rgba($quanteecblue, 0.17) 2px 4px 14px, 5px -5px 0px $quanteeccut;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblue !important;
    &:hover {
      box-shadow: rgba($quanteecblue, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px, 5px -5px 0px $quanteeccut;
      transform: scale(0.91);
    }
}
.mycardVODwCutExp {
    box-shadow: rgba($quanteecblue, 0.17) 2px 4px 14px, rgba($quanteecblue, 0.17) 2px 4px 14px, 8px 0px 0px $quanteeccut;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblue !important;
    &:hover {
      box-shadow: rgba($quanteecblue, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px, 8px 0px 0px $quanteeccut;
      transform: scale(0.91);
    }
}

.mycardArchive {
    box-shadow: rgba($quanteecarchive, 0.17) 2px 4px 14px, rgba($quanteecarchive, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: rgba($quanteecarchive, 0.027647);
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecarchive !important;
    &:hover {
      box-shadow: rgba($quanteecarchive, 0.3) 4px 8px 20px, rgba($quanteecarchive, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.mycardCut {
    box-shadow: rgba($quanteeccut, 0.17) 2px 4px 14px, rgba($quanteeccut, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: rgba($quanteeccut, 0.027647);
    border-radius: 5px !important;
    border: 0.15rem solid $quanteeccut !important;
    &:hover {
      box-shadow: rgba($quanteeccut, 0.3) 4px 8px 20px, rgba($quanteeccut, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.mycardArchiveImb {
    box-shadow: rgba($quanteecarchive, 0.17) 2px 4px 14px, rgba($quanteecarchive, 0.17) 2px 4px 14px, -8px 0px 0px $quanteecarchive;
    transition: .15s all ease-in-out;
    transform: scale(0.86);
    background-color: rgba($quanteecarchive, 0.027647);
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecarchive !important;
//    outline: 15px solid rgba($quanteecarchive, 0.17);        
    &:hover {
      box-shadow: rgba($quanteecarchive, 0.3) 4px 8px 20px, rgba($quanteecarchive, 0.3) 4px 8px 20px, -8px 0px 0px $quanteecarchive;
      transform: scale(0.87);
    }
}
.mycardArchiveImbwCut {
    box-shadow: rgba($quanteecarchive, 0.17) 2px 4px 14px, rgba($quanteecarchive, 0.17) 2px 4px 14px, 5px -5px 0px $quanteeccut, -8px 0px 0px $quanteecarchive;
    transition: .15s all ease-in-out;
    transform: scale(0.86);
    background-color: rgba($quanteecarchive, 0.027647);
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecarchive !important;
//    outline: 15px solid rgba($quanteecarchive, 0.17);        
    &:hover {
      box-shadow: rgba($quanteecarchive, 0.3) 4px 8px 20px, rgba($quanteecarchive, 0.3) 4px 8px 20px, 5px -5px 0px $quanteeccut, -8px 0px 0px $quanteecarchive;
      transform: scale(0.87);
    }
}
.mycardArchiveImbwCutExp {
    box-shadow: rgba($quanteecarchive, 0.17) 2px 4px 14px, rgba($quanteecarchive, 0.17) 2px 4px 14px, 8px 0px 0px $quanteeccut, -8px 0px 0px $quanteecarchive;
    transition: .15s all ease-in-out;
    transform: scale(0.86);
    background-color: rgba($quanteecarchive, 0.027647);
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecarchive !important;
//    outline: 15px solid rgba($quanteecarchive, 0.17);        
    &:hover {
      box-shadow: rgba($quanteecarchive, 0.3) 4px 8px 20px, rgba($quanteecarchive, 0.3) 4px 8px 20px, 8px 0px 0px $quanteeccut, -8px 0px 0px $quanteecarchive;
      transform: scale(0.87);
    }
}

.mycardCutImb {
    box-shadow: rgba($quanteeccut, 0.17) 2px 4px 14px, rgba($quanteeccut, 0.17) 2px 4px 14px, -8px 0px 0px $quanteeccut;
    transition: .15s all ease-in-out;
    transform: scale(0.85);
    background-color: rgba($quanteeccut, 0.027647);
    border-radius: 5px !important;
    border: 0.15rem solid $quanteeccut !important;
    &:hover {
      box-shadow: rgba($quanteeccut, 0.3) 4px 8px 20px, rgba($quanteeccut, 0.3) 4px 8px 20px, -8px 0px 0px $quanteeccut;
      transform: scale(0.86);
    }
}

.mycard {
    box-shadow: rgba($quanteecyellow, 0.17) 2px 4px 14px, rgba($quanteecyellow, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecyellow !important;
    &:hover {
      box-shadow: rgba($quanteecyellow, 0.3) 4px 8px 20px, rgba($quanteecyellow, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.mycard2 {
    box-shadow: rgba($quanteecgreen, 0.17) 2px 4px 14px, rgba($quanteecgreen, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2 !important;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecgreen !important;
    &:hover {
      box-shadow: rgba($quanteecgreen, 0.3) 4px 8px 20px, rgba($quanteecgreen, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.mycard3 {
    box-shadow: rgba($quanteecyellow, 0.17) 2px 4px 14px, rgba($quanteecyellow, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecyellow !important;
    &:hover {
      box-shadow: rgba($quanteecyellow, 0.3) 4px 8px 20px, rgba($quanteecyellow, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.mycard4 {
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecred !important;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

.mycard5 {
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: $quanteecwhite2;
    border-radius: 5px !important;
    border: 0.15rem solid $quanteecblack !important;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px;
      transform: scale(0.91);
    }
}

/*
.mycard3 {
    box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: rgba($msstreamyellow1, 0.117647);
    &:hover {
      box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
      transform: scale(0.91);
    }
}

.mycard4 {
    box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: rgba($msstreamred1, 0.317647);
    &:hover {
      box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
      transform: scale(0.91);
      cursor: pointer;
    }
}

.mycard5{
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
    background-color: rgba($backgrounddark, 0.317647);
    &:hover {
      box-shadow: rgba($backgrounddark, 0.3) 1px 2px 7px, rgba($backgrounddark, 0.3) 1px 2px 7px;
      transform: scale(0.91);
      cursor: pointer;
    }
}
*/

.cardLiveOn {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px;
    border: 0.12rem solid $quanteecred !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px;
      transform: scale(1.00);
    }
}

.cardLiveOnImb {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px;
    border: 0.12rem solid $quanteecred !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px;
      transform: scale(1.00);
    }
}
.cardLiveOnwA {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px, 4px -4px 0px $quanteecarchive;
    border: 0.12rem solid $quanteecred !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px, 4px -4px 0px $quanteecarchive;
      transform: scale(1.00);
    }
}
.cardLiveOnwAExp {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecred, 0.17) 2px 4px 14px, rgba($quanteecred, 0.17) 2px 4px 14px, 0px 5px 0px $quanteecarchive;
    border: 0.12rem solid $quanteecred !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecred, 0.3) 4px 8px 20px, rgba($quanteecred, 0.3) 4px 8px 20px, 0px 5px 0px $quanteecarchive;
      transform: scale(1.00);
    }
}

.cardLiveStop {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px;
    border: 0.12rem solid $quanteecblack !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px;
      transform: scale(1.00);
    }
}
.cardLiveStopImb {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px;
    border: 0.12rem solid $quanteecblack !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px;
      transform: scale(1.00);
    }
}
.cardLiveStopwA {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px, 4px -4px 0px $quanteecarchive;
    border: 0.12rem solid $quanteecblack !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px, 4px -4px 0px $quanteecarchive;
      transform: scale(1.00);
    }
}
.cardLiveStopwAExp {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecblack, 0.17) 2px 4px 14px, rgba($quanteecblack, 0.17) 2px 4px 14px, 0px 5px 0px $quanteecarchive;
    border: 0.12rem solid $quanteecblack !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecblack, 0.3) 4px 8px 20px, rgba($quanteecblack, 0.3) 4px 8px 20px, 0px 5px 0px $quanteecarchive;
      transform: scale(1.00);
    }
}

.cardVOD {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecblue, 0.17) 2px 4px 14px, rgba($quanteecblue, 0.17) 2px 4px 14px;
    border: 0.12rem solid $quanteecblue !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecblue, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px;
      transform: scale(1.00);
    }
}
.cardVODImb {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecblue, 0.17) 2px 4px 14px, rgba($quanteecblue, 0.17) 2px 4px 14px;
    border: 0.12rem solid $quanteecblue !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecblue, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px;
      transform: scale(1.00);
    }
}
.cardVODwCut {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecblue, 0.17) 2px 4px 14px, rgba($quanteecblue, 0.17) 2px 4px 14px, 4px -4px 0px $quanteeccut; 
    border: 0.12rem solid $quanteecblue !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecblue, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px, 4px -4px 0px $quanteeccut; 
      transform: scale(1.00);
    }
}
.cardVODwCutExp {
    background-color: $quanteecwhite2;
    box-shadow: rgba($quanteecblue, 0.17) 2px 4px 14px, rgba($quanteecblue, 0.17) 2px 4px 14px, 0px 5px 0px $quanteeccut;
    border: 0.12rem solid $quanteecblue !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecblue, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px, 0px 5px 0px $quanteeccut;
      transform: scale(1.00);
    }
}


.cardArchive {
    background-color: rgba($quanteecarchive, 0.027647);
    box-shadow: rgba($quanteecarchive, 0.17) 2px 4px 14px, rgba($quanteecarchive, 0.17) 2px 4px 14px;
    border: 0.12rem solid $quanteecarchive !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecarchive, 0.3) 4px 8px 20px, rgba($quanteecarchive, 0.3) 4px 8px 20px;
      transform: scale(1.00);
    }
}

.cardCut {
    background-color: rgba($quanteeccut, 0.027647);
    box-shadow: rgba($quanteeccut, 0.17) 2px 4px 14px, rgba($quanteeccut, 0.17) 2px 4px 14px;
    border: 0.12rem solid $quanteeccut !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteeccut, 0.3) 4px 8px 20px, rgba($quanteeccut, 0.3) 4px 8px 20px;
      transform: scale(1.00);
    }
}

.cardArchiveImb {
    background-color: rgba($quanteecarchive, 0.027647);
    box-shadow: rgba($quanteecarchive, 0.17) 2px 4px 14px, rgba($quanteecarchive, 0.17) 2px 4px 14px, -8px 0px 0px $quanteecarchive;
    border: 0.12rem solid $quanteecarchive !important;
    border-radius: 3px;
    transform: scale(0.97);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecarchive, 0.3) 4px 8px 20px, rgba($quanteecarchive, 0.3) 4px 8px 20px, -8px 0px 0px $quanteecarchive;
      transform: scale(0.98);
    }
}
.cardArchiveImbwCut {
    background-color: rgba($quanteecarchive, 0.027647);
    box-shadow: rgba($quanteecarchive, 0.17) 2px 4px 14px, rgba($quanteecarchive, 0.17) 2px 4px 14px, 3px -1px 0px $quanteeccut, -8px 0px 0px $quanteecarchive; 
    border: 0.12rem solid $quanteecarchive !important;
    border-radius: 3px;
    transform: scale(0.97);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecarchive, 0.3) 4px 8px 20px, rgba($quanteecarchive, 0.3) 4px 8px 20px, 3px -1px 0px $quanteeccut, -8px 0px 0px $quanteecarchive; 
      transform: scale(0.98);
    }
}
.cardArchiveImbwCutExp {
    background-color: rgba($quanteecarchive, 0.027647);
    box-shadow: rgba($quanteecarchive, 0.17) 2px 4px 14px, rgba($quanteecarchive, 0.17) 2px 4px 14px, 0px 5px 0px $quanteeccut, -8px 0px 0px $quanteecarchive;
    border: 0.12rem solid $quanteecarchive !important;
    border-radius: 3px;
    transform: scale(0.97);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteecarchive, 0.3) 4px 8px 20px, rgba($quanteecblue, 0.3) 4px 8px 20px, 0px 5px 0px $quanteeccut, -8px 0px 0px $quanteecarchive;
      transform: scale(0.98);
    }
}

.cardCutImb {
    background-color: rgba($quanteeccut, 0.027647);
    box-shadow: rgba($quanteeccut, 0.17) 2px 4px 14px, rgba($quanteeccut, 0.17) 2px 4px 14px, -8px 0px 0px $quanteeccut;
    border: 0.12rem solid $quanteeccut !important;
    border-radius: 3px;
    transform: scale(0.95);
    transition: .25s all ease-in-out;
    &:hover {
      box-shadow: rgba($quanteeccut, 0.3) 4px 8px 20px, rgba($quanteeccut, 0.3) 4px 8px 20px, -8px 0px 0px $quanteeccut;
      transform: scale(0.96);
    }
}

.cardTemplate1 {
    background-color: red;
    border: 0.12rem solid red !important;
    border-radius: 3px;
    transition: .25s all ease-in-out;
}
.cardTemplate2 {
    background-color: blue;
    border: 0.12rem solid red !important;
    border-radius: 3px;
    transition: .25s all ease-in-out;
}


.cardList2 {
    background-color: $quanteecwhite2;
    border: 0.12rem solid $quanteecgreen !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      transform: scale(1.00);
    }
}

.cardList3 {
    background-color: $quanteecwhite2;
    border: 0.12rem solid $quanteecyellow !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      transform: scale(1.00);
    }
}

.cardList4 {
    background-color: $quanteecwhite2;
    border: 0.12rem solid $quanteecred !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      transform: scale(1.00);
    }
}

.cardList5 {
    background-color: $quanteecwhite2;
    border: 0.12rem solid $quanteecblack !important;
    border-radius: 3px;
    transform: scale(0.99);
    transition: .25s all ease-in-out;
    &:hover {
      transform: scale(1.00);
    }
}

.analyticscard{ 
  box-shadow: rgba($backgrounddark, 0.117647) 1px 2px 7px, rgba($backgrounddark, 0.117647) 1px 2px 7px;
    transition: .15s all ease-in-out;
    transform: scale(0.9);
}

.elemRightMenu {
  border-bottom: 1px solid grey;
}

.msstreamElemRightMenu {
  color: $msstreamblue1;
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}

.backgroundRightMenu {
  color: $colortextgrey !important;
  background-color: $backgrounddark !important;
  border-color: $backgrounddark !important;
}

.msstream-prepend {
    background-color: $msstreamblue1 !important;
    color: white !important;
    border-color: $msstreamblue1 !important;
}

.msstream-input {
  border-color: $msstreamblue1 !important;
}

body {
    line-height: 1 !important;
} 

.progress-bar-animated.bg-quanteec {
  background-color: $quanteecblue !important;
}

.progress-bar-animated.bg-quanteecdanger {
  background-color: $quanteecred !important;
}


@media (min-width: 992px) {
  .container {
    max-width: 1500px !important;
  }    
} 

/*
.row+.row {
    margin-top: 0px; 
}

.row + .row {
     margin-top: 0px; 
}
*/

</style>
